import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedTranslationModule } from '@shared/translation.module';

@Component({
  selector: 'md-info-block',
  imports: [TranslateModule, SharedTranslationModule],
  templateUrl: './info-block.component.html',
  styleUrl: './info-block.component.scss',
  standalone: true
})
export class InfoBlockComponent {
  title = input<string>('');
  text = input<string | undefined | null>('');
}
